import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../dashboard/dashboard.css";
import { Card, CardBody, CardHeader, Col, Input, Row } from "reactstrap";
import { Table, Button } from "antd";
import moment from "moment";
import coin1 from "assets/img/coin1.png";
import coin2 from "assets/img/coin2.png";
import coin3 from "assets/img/coin3.png";
import { connect } from "react-redux";
import apiurl from "../../../apiurl";
import axios from "axios";
import BlockUi from "react-block-ui";

const mapDispatchToProps = (dispatch) => {
  return {
    // login: (payload) => {
    //   dispatch(login(payload))
    // },
    // addParams: (payload) => {
    //   dispatch(addParams(payload));
    // }
  };
};

const mapStateToProps = (state) => {
  const user = state.user;
  return {
    schoolId: user && user.school_id,
    boardId: user && user.boardId,
    isPace: user && user.isPace,
  };
};

// =================================================================================================================

class Detail extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
    this.toggle = this.toggle.bind(this);

    //===================== STATE ====================

    this.state = {
      dropdownOpen: false,
      radioSelected: 2,
      dashboard: null,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      pageLoading: true,
      activeTab: "V",
      currentSelectedGrade: "V",
      studentGradeData: "",
      indicator_gradewisedata: "",
      gradeMaster: "",
      primary: false,
      completionRatedoughnutLabelArr: [],
      completionRatedoughnutDataArr: [],
      studenttableData: [],
      pagination: {},
      cardHeaderTitle: "",
      showCsvDwnldBtn: false,
      searchname: "",
      searchFlag: false,
    };
    this.chartReference = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  onRadioBtnClick(radioSelected) {
    this.setState({
      radioSelected: radioSelected,
    });
  }

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  //=============================================================================================================

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  btnBack() {
    this.props.history.goBack();
    // let path = `/principal`;
    // this.props.history.push({
    //     pathname: path,
    // });
  }

  async handleTableChange(pagination) {
    let category = this.props.location.state.category;
    let pagiVal = pagination.current;
    console.log(pagiVal);
    this.setState({
      pageLoading: true,
    });
    if (this.state.searchFlag === false) {
      if (category === "simplebar-studentlist") {
        this.getbarChartStudentData(pagiVal);
      } else if (category === "mixbar-studentlist") {
        this.getMixbarChartStudentData(pagiVal);
      } else {
        this.getData(pagiVal);
      }
    } else {
      this.searchStudentInfo(pagiVal);
    }
  }

  // resetStudentInfoTbl = async () => {
  //   console.log("reset");
  //   // this.setState({
  //   // });
  //   await this.componentDidMount();
  //   this.setState({
  //     searchname: "",
  //     searchFlag: false,
  //     pageLoading: true

  //   });
  // };
  searchBarUpdate = (e) => {
    this.setState({
      searchname: e.target.value,
    });
  };

  getStudentDetail(selectedRowKeys, selectedRows) {
    let selectedUser_id = selectedRows.user_id;
    let selectedGrade_id = localStorage.getItem("selectedGrade_id"); // Grade ID
    let selectedBoard_id = localStorage.getItem("finalBoard_id"); // Board ID
    const payload = {
      studentId: selectedUser_id,
      gradeId: selectedGrade_id,
      boardId: selectedBoard_id,
    };
    // this.props.addParams(payload);
    this.props.history.push("/student/dashboard");
  }

  async getData(pagiVal) {
    let schoolId = this.props.location.state.schoolId;
    let selectedBoard_id = localStorage.getItem("finalBoard_id"); // Board ID
    let defaultGradeVallocalstrgStatApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );

    let statisticsResult = await axios.get(
      "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/statistics-dev",
      {
        params: {
          schoolId: this.props.schoolId,
          page: pagiVal,
          boardId: selectedBoard_id,
          gradeId: defaultGradeVallocalstrgStatApi,
        },
      }
    );
    statisticsResult = statisticsResult.data;

    let type = this.props.location.state.type;
    let selectedData = [];
    var pagiObj = {};
    if (type === "Registered Students") {
      selectedData = statisticsResult.school.register_students;
      pagiObj.total = statisticsResult.school.total_students;
    } else if (type === "Active Students") {
      selectedData = statisticsResult.school.active_students;
      pagiObj.total = statisticsResult.school.active_count;
    } else if (type === "Inactive Students") {
      selectedData = statisticsResult.school.inactive_students;
      pagiObj.total = statisticsResult.school.inactive_count;
    }
    pagiObj.current = pagiVal;
    pagiObj.showSizeChanger = false;

    this.setState({
      studenttableData: selectedData,
      pagination: pagiObj,
      schoolId: schoolId,
      boardId: selectedBoard_id,
      cardHeaderTitle: type,
      showCsvDwnldBtn: true,
      pageLoading: false,
    });
  }

  async getbarChartStudentData(pagiVal) {
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    let selectedGrade_id = localStorage.getItem("selectedGrade_id");
    let gradeName = localStorage.getItem("selectedGrade_Name");
    let barlabelval = this.props.location.state.barlabelval;
    let cardTitle = this.props.location.state.cardTitle;
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    var pagiObj = {};
    let barchartStudentList;
    if (
      selectedGrade_id_statisticApi === "" ||
      selectedGrade_id_statisticApi === null
    ) {
      barchartStudentList = await window.$http.post(
        apiurl.barchartStudentListApi,
        {
          schoolId: finalSchool_id,
          gradeId: selectedGrade_id,
          page: pagiVal,
          range: barlabelval,
          grade: gradeName,
          param: "all",
        }
      );
    } else {
      barchartStudentList = await window.$http.post(
        apiurl.barchartStudentListApi,
        {
          schoolId: finalSchool_id,
          gradeId: selectedGrade_id,
          page: pagiVal,
          range: barlabelval,
          grade: gradeName,
        }
      );
    }

    let barChartStudentList = barchartStudentList.barChart.report;
    pagiObj.total = barchartStudentList.barChart.studentCount;

    this.setState({
      studenttableData: barChartStudentList,
      pagination: pagiObj,
      cardHeaderTitle: cardTitle,
      showCsvDwnldBtn: false,
    });
  }

  async getMixbarChartStudentData(pagiVal) {
    let stuType = localStorage.getItem("mixChartSelectBarTypeStuList");
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    let selectedGrade_id = this.props.location.state.selectedGrdId;
    let selectedGrade_Name = this.props.location.state.selectedGrdName;
    let selectedGradeRomanval = this.props.location.state.selectedGradeRomanval;
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    var pagiObj = {};
    let mixbarchartStudentList;
    if (
      selectedGrade_id_statisticApi === "" ||
      selectedGrade_id_statisticApi === null
    ) {
      mixbarchartStudentList = await window.$http.post(
        apiurl.barchartStudentListApi,
        {
          schoolId: finalSchool_id,
          gradeId: selectedGrade_id,
          page: pagiVal,
          range: "",
          action: "activeInactive",
          grade: selectedGrade_Name,
          param: "all",
        }
      );
    } else {
      mixbarchartStudentList = await window.$http.post(
        apiurl.barchartStudentListApi,
        {
          schoolId: finalSchool_id,
          gradeId: selectedGrade_id,
          page: pagiVal,
          range: "",
          action: "activeInactive",
          grade: selectedGrade_Name,
        }
      );
    }

    let studenttableData;
    let paginationCount;
    if (stuType === "Active Students") {
      studenttableData = mixbarchartStudentList.barChart.activeStudentReport;
      paginationCount = mixbarchartStudentList.barChart.activeStudentCount;
    } else {
      studenttableData = mixbarchartStudentList.barChart.inactiveStudentReport;
      paginationCount = mixbarchartStudentList.barChart.inactiveStudentCount;
    }
    pagiObj.total = paginationCount;
    let cardHeaderTitle = stuType + " of Grade - " + selectedGradeRomanval;
    this.setState({
      studenttableData: studenttableData,
      pagination: pagiObj,
      cardHeaderTitle: cardHeaderTitle,
      showCsvDwnldBtn: false,
    });
  }

  async downloadCsv() {
    let gradeId = localStorage.getItem("selectedGrade_id");
    let gradeId_Stats = localStorage.getItem("selectedGrade_id_statisticApi");
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    // let boardId = this.state.boardId;
    let stuType = localStorage.getItem("mixChartSelectBarTypeStuList");
    let user_mobile = localStorage.getItem("user_mobile");
    let type = this.props.location.state.type;
    let filterparam;
    let finalGrade;
    if (type === "Registered Students") {
      filterparam = "register";
      finalGrade = gradeId_Stats;
    } else if (type === "Active Students") {
      filterparam = "active";
      finalGrade = gradeId_Stats;
    } else if (type === "Inactive Students") {
      filterparam = "inactive";
      finalGrade = gradeId_Stats;
    } else if (stuType === "Active Students") {
      filterparam = "active";
      finalGrade = gradeId;
    } else if (stuType === "Inactive Students") {
      filterparam = "inactive";
      finalGrade = gradeId;
    }

    // const downloadCsvResult = await window.$http.post('principal/schoolreportdownload', {
    // const downloadCsvResult = await window.$http.post('principal/schoolreport/schoolreportdownload-dev', {
    //     schoolId: finalSchool_id,
    //     // gradeId: gradeId,
    //     gradeId: finalGrade,
    //     param: filterparam,
    //     // boardId: boardId,
    //     // page: 1,
    // });

    let downloadCsvResult;
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    if (
      selectedGrade_id_statisticApi === "" ||
      selectedGrade_id_statisticApi === null
    ) {
      downloadCsvResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/schoolreport/schoolreportdownload-dev",
        {
          schoolId: this.props.schoolId,
          param: filterparam,
          authMobile: user_mobile,
        }
      );
    } else {
      downloadCsvResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/schoolreport/schoolreportdownload-dev",
        {
          schoolId: this.props.schoolId,
          gradeId: finalGrade,
          param: filterparam,
          authMobile: user_mobile,
        }
      );
    }
    downloadCsvResult = downloadCsvResult.data;
    window.open(downloadCsvResult.path, "_blank"); //to open new page
  }

  searchStudentInfo = async (pagiVal) => {
    console.log(pagiVal);
    let type = this.props.location.state.type;
    console.log(type);
    console.log(this.state.pageValue);
    let filterparam;
    let finalGrade;
    if (type === "Registered Students") {
      filterparam = "register";
    } else if (type === "Active Students") {
      filterparam = "active";
    } else if (type === "Inactive Students") {
      filterparam = "inactive";
    }
    let searchStudentResult;
    let singleSelectFlag = localStorage.getItem("singleSelectFlag");
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    let grade = localStorage.getItem("selectedGrade_id_statisticApi");
    let board = localStorage.getItem("finalBoard_id");
    let searchname = this.state.searchname;
    console.log(this.state.pagination);
    this.setState({
      pageLoading: true,
    });
    searchStudentResult = await axios.post(
      "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/air-searchuser",
      {
        schoolId: this.props.schoolId,
        // boardId: “5e8c428336bf63c0c1f65726",
        // boardId: board,
        page: pagiVal,
        param: filterparam,
        // action: singleSelectFlag,
        search: searchname,
        gradeId: grade,
      }
    );
    console.log(searchStudentResult);
    searchStudentResult = searchStudentResult.data;
    let pageObj = {};
    let selectedDataList;
    // pageObj.total = searchStudentResult.user.totalCount;
    if (type === "Registered Students") {
      selectedDataList = searchStudentResult.path.user;
      pageObj.total = searchStudentResult.path.totalCount;
    } else if (type === "Active Students") {
      selectedDataList = searchStudentResult.path.user;
      pageObj.total = searchStudentResult.path.totalCount;
    } else if (type === "Inactive Students") {
      selectedDataList = searchStudentResult.path.user;
      pageObj.total = searchStudentResult.path.totalCount;
    }
    pageObj.current = pagiVal;
    console.log(selectedDataList);
    console.log(pageObj.total);
    if (pageObj.total === 0) {
      selectedDataList = [];
    }
    this.setState({
      searchFlag: false,
      studenttableData: selectedDataList,
      pagination: pageObj,
      pageLoading: false,
    });
  };

  resetStudentInfoTbl = async () => {
    console.log("reset");
    this.setState({
      pageLoading: true,
    });
    await this.componentDidMount();
    this.setState({
      searchname: "",
      searchFlag: false,
    });
  };

  //===================================================

  componentDidMount() {
    let pagiVal = 1;
    let category = this.props.location.state.category;
    if (category === "simplebar-studentlist") {
      this.getbarChartStudentData(pagiVal);
    } else if (category === "mixbar-studentlist") {
      this.getMixbarChartStudentData(pagiVal);
    } else {
      this.getData(pagiVal);
    }

    //=======================================  CHAPTER COMPLETION COUNT API ========================================

    // axios.get('https://0e3r24lsu5.execute-api.ap-south-1.amazonaws.com/Prod/getchaptercompletioncount?school_id=350')
    //     .then(res => {
    //         let completionData = res.data.school.chapter_completion_count;
    //         let completionRatedoughnutLabelArr = [];
    //         let completionRatedoughnutDataArr = [];
    //         for (let i = 0; i < completionData.length; i++) {
    //             completionRatedoughnutLabelArr.push(completionData[i].key);
    //             completionRatedoughnutDataArr.push(completionData[i].game_played_last_month.buckets[0].doc_count)
    //             // let completionRateCount = completionRatedoughnutDataArr.reduce((a, b) => a + b)
    //             // let res = completionRateCount / 256628 * 4
    //         }
    //         this.setState({
    //             completionRatedoughnutLabelArr: completionRatedoughnutLabelArr,
    //             completionRatedoughnutDataArr: completionRatedoughnutDataArr
    //         });
    //     })
  }

  render() {
    let carddetailTblcolumns;
    let category = this.props.location.state.category;

    if (category === "card-studentlist") {
      carddetailTblcolumns = [
        // {
        //     title: 'User Id',
        //     dataIndex: 'user_id',
        //     key: 'user_id',
        //     render: text => <span>{text}</span>,
        // },
        {
          title: "Name",
          dataIndex: "full_name",
          key: "full_name",
        },
        // {
        //     title: 'Mobile No',
        //     dataIndex: 'mobile_no',
        //     key: 'mobile_no',
        // },
        {
          title: "Grade",
          dataIndex: "grade_roman",
          key: "grade_roman",
          render: (text) => (
            <span>
              <span>{text}</span>
            </span>
          ),
        },
        {
          title: "School Name",
          dataIndex: "school_name",
          key: "school_name",
          render: (text) => (
            <span>
              <span>{text}</span>
            </span>
          ),
        },
        {
          title: "Board Name",
          dataIndex: "board_name",
          key: "board_name",
        },
        // {
        //     title: 'User Email',
        //     dataIndex: 'email_id',
        //     key: 'email_id',
        // },
      ];

      let type = this.props.location.state.type;

      if (type === "Active Students") {
        carddetailTblcolumns = carddetailTblcolumns.filter(
          (item) => item.key !== "email_id"
        );
      }
    } else if (category === "simplebar-studentlist") {
      carddetailTblcolumns = [
        {
          title: "Full Name",
          dataIndex: "fullname",
          key: "fullname",
        },
        {
          title: "Knowledge Wealth",
          dataIndex: "knowledge_wealth",
          key: "knowledge_wealth",
          render: (text) => (
            <div className="gcoin_css gcoin_dmd">
              <img src={coin1} alt="dimond images" height={50} />
              <span className="coin_nums">{text}</span>
            </div>
          ),
        },
        {
          title: "Knowledge Currency",
          dataIndex: "knowledge_currency",
          key: "knowledge_currency",
          render: (text) => (
            <div className="gcoin_css">
              <img src={coin2} alt="dimond images" height={50} />
              <span className="coin_nums">{text}</span>
            </div>
          ),
        },
        {
          title: "Learning Currency",
          dataIndex: "learning_currency",
          key: "learning_currency",
          render: (text) => (
            <div className="gcoin_css">
              <img src={coin3} alt="dimond images" height={50} />
              <span className="coin_nums">{text}</span>
            </div>
          ),
        },
        {
          title: "Time Spent",
          dataIndex: "time_spend",
          key: "time_spend",
          render: (text) => (
            <span>{moment.utc(text * 1000).format("HH:mm:ss")}</span>
          ),
        },
        {
          title: "Action",
          dataIndex: "",
          key: "x",
          align: "right",
          render: (selectedRowKeys, selectedRows) => (
            <Button
              className="btn btn-outline"
              onClick={() =>
                this.getStudentDetail(selectedRowKeys, selectedRows)
              }
            >
              View details <icon className="icon-next"></icon>
            </Button>
          ),
        },
      ];
    } else if (category === "mixbar-studentlist") {
      carddetailTblcolumns = [
        {
          title: "User Id",
          dataIndex: "user_id",
          key: "user_id",
          render: (text) => <span>{text}</span>,
        },
        {
          title: "UserName",
          dataIndex: "full_name",
          key: "full_name",
        },
        {
          title: "Grade",
          dataIndex: "grade_roman",
          key: "grade_roman",
          render: (text) => (
            <span>
              <span>{text}</span>
            </span>
          ),
        },
        {
          title: "School Name",
          dataIndex: "school_name",
          key: "school_name",
          render: (text) => (
            <span>
              <span>{text}</span>
            </span>
          ),
        },
        {
          title: "Board Name",
          dataIndex: "board_name",
          key: "board_name",
        },
        {
          title: "User Email",
          dataIndex: "email_id",
          key: "email_id",
        },
      ];
      let stuType = localStorage.getItem("mixChartSelectBarTypeStuList");
      if (stuType === "Active Students") {
        carddetailTblcolumns = carddetailTblcolumns.filter(
          (item) => item.key !== "email_id"
        );
      }
    }
    let carddetailTbldata = this.state.studenttableData;
    if (carddetailTbldata.length !== 0) {
      for (let i = 0; i < carddetailTbldata.length; i++) {
        carddetailTbldata[i].key = i;
      }
    }

    return (
      <>
        <div id="CommonPageHolder">
          <div className="container-fluid">
            <div className="row no-gutters top-fixed-bar head-bread-crumb-dashboard">
              <div
                className="back-nav"
                aria-pressed="true"
                onClick={this.btnBack.bind(this)}
              >
                <icon className="icon-back-arrow"></icon>
              </div>
              <div className="col bread-crumb px-0 pl-2">Students</div>
              <div className="back-nav-btn text-right"></div>
            </div>
           
            <Card>
              <CardHeader className="dash-card-header">
                {this.state.cardHeaderTitle}
              </CardHeader>
              <CardBody className="pt-0">
                <div className=" row  no-gutters width-100 d-f-c pb-2">
                  <div className="col-md-6 my-2 mx-1">
                    <Input
                      type="text"
                      id="studentName"
                      name="studentName"
                      placeholder="Name"
                      value={this.state.searchname}
                      onChange={this.searchBarUpdate}
                    />
                  </div>
                  <div class="width-auto" className="searchbuttongrp">
                    <Button
                      type="submit"
                      size="sm"
                      color="primary"
                      className="my-2 mx-1"
                      onClick={() => {
                        this.searchStudentInfo(1);
                      }}
                    >
                      <icon
                        className="icon-search-01"
                        aria-hidden="true"
                      ></icon>
                    </Button>
                    <Button
                      type="submit"
                      size="sm"
                      color="primary"
                      className="my-2 mx-1"
                      onClick={this.resetStudentInfoTbl}
                    >
                      <icon className="icon-refresh" aria-hidden="true"></icon>
                    </Button>
                    {this.state.showCsvDwnldBtn && (
                      <Button
                        type="button"
                        size="sm"
                        color="primary"
                        className="my-2 mx-1"
                        onClick={this.downloadCsv}
                      >
                        <icon
                          className="icon-install"
                          aria-hidden="true"
                        ></icon>
                        <span>&nbsp;csv</span>
                      </Button>
                    )}
                  </div>
                </div>
                <div className="row no-gutters ">
                  <BlockUi
                    tag="div"
                    className="width-100"
                    blocking={this.state.pageLoading}
                    keepInView
                  >
                    <div  className="width-100">
                      <Table
                        pagination={this.state.pagination}
                        columns={carddetailTblcolumns}
                        dataSource={carddetailTbldata}
                        onChange={this.handleTableChange.bind(this)}
                      />
                    </div>
                  </BlockUi>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Detail));
